import { ProjectEffects } from './projects.effect';
import { ContactsEffects } from './contacts.effect';
import { VersionsEffects } from './version.effect';
import { ResultEffects } from './result.effect';
import { CreditsEffects } from './credits.effect';
import { CompareEffects } from './compare.effect';
import { TreeEffects } from './tree.effects';

// mapper
import { MappingEffects } from './mapping.effect';
import { MaterialsEffects } from './materials.effect';

export const effects: any[] = [
  ProjectEffects,
  ContactsEffects,
  VersionsEffects,
  ResultEffects,
  CreditsEffects,
  CompareEffects,
  TreeEffects,
  MappingEffects,
  MaterialsEffects,
];

export * from './projects.effect';
export * from './contacts.effect';
export * from './version.effect';
export * from './result.effect';
export * from './credits.effect';
export * from './compare.effect';
export * from './tree.effects';
export * from './mapping.effect';
export * from './materials.effect';
